import { ACTION_TYPES } from '../constants';

export default (data, slug) => ({
  type: ACTION_TYPES.FETCH_SUCCESS,
  payload: {
    data,
    slug
  }
});
